import { registerCommonActionsMenuItem } from '@ecosystem/newron-client-lib';
import React from 'react';

import { AddInsightToCollectionsActionProps, AddInsightToCollectionsActionType } from '../../shared/types';

import { AddInsightToCollectionsAction } from './AddInsightToCollectionsAction';

export type AddInsightToCollectionsMenuItemProps<TInsightData extends object, TViewState extends object> = Omit<
  AddInsightToCollectionsActionProps<TInsightData, TViewState>,
  'actionType'
>;

function AddInsightToCollectionsMenuItem<TInsightData extends object, TViewState extends object>(
  props: AddInsightToCollectionsMenuItemProps<TInsightData, TViewState>
): JSX.Element {
  return <AddInsightToCollectionsAction {...props} actionType={AddInsightToCollectionsActionType.MenuItem} />;
}

registerCommonActionsMenuItem(AddInsightToCollectionsMenuItem as React.FC, 2);

export { AddInsightToCollectionsMenuItem };
